<template>
  <div class="navbar_btn">
    <!-- <router-link v-if="hasTeam==1"
      tag="div"
      to="/smartOffice/StruggleReport"
      :class="['navbar_list',tab==0 ? 'cur' :'']"
    > -->
    <div v-if="hasTeam==1" :class="['navbar_list',tab==0 ? 'cur' :'']" @click="pushView(0)">
       <img  class="theme_img" :src="tab==0 ?require('@/assets/images/StruggleTabbar/icon_team_selected.png'):require('@/assets/images/StruggleTabbar/icon_team_normal.png')">
       <div v-if="tab==0" class="theme_2span">团队</div>
       <span v-else >团队</span>
    </div>
    <!-- </router-link> -->
    <!-- <router-link
      tag="div"
      to="/smartOffice/StruggleCalendar"
      :class="['navbar_list',tab==1 ? 'cur' :'']"
    > -->
     <div  :class="['navbar_list',tab==1 ? 'cur' :'']" @click="pushView(1)">
        <img class="theme_img"   :src="tab==1 ?require('@/assets/images/StruggleTabbar/icon_calendar_selected.png'):require('@/assets/images/StruggleTabbar/icon_calendar_normal.png')">
        <div v-if="tab==1" class="theme_2span">日历</div>
        <span v-else>日历</span>
     </div>
    <!-- </router-link> -->
    <!-- <router-link
      tag="div"
      to="/smartOffice/StruggleMonthlyReport"
      :class="['navbar_list',tab==2 ? 'cur' :'']"
    > -->
    <div  :class="['navbar_list',tab==2 ? 'cur' :'']" @click="pushView(2)">
      <img class="theme_img" :src="tab==2 ?require('@/assets/images/StruggleTabbar/icon_report_selected.png'):require('@/assets/images/StruggleTabbar/icon_report_normal.png')">
      <div v-if="tab==2" class="theme_2span">月报</div>
      <span v-else>月报</span>
    </div>
    <!-- </router-link> -->
  </div>
</template>
<script>
import { mapState } from 'vuex';
export default {
  name: 'navBar',
  props: {
    tab:{
      type:Number,
      default:0
    },
  },
  data () {
    return {
      hasTeam :0,
      navList: [],
    };
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  created () {
     var roleId = this.common.userTenantInfo.roleId;
        if(roleId =='1' ||roleId =='2'){
            this.hasTeam =1;
        }else{
            this.hasTeam=0;
        }
  },

  methods: {
     pushView(index){
       if(index==this.tab){
         return;
       }
       var url =''
       if(index ==0){
          url ='/smartOffice/StruggleReport';
       }else if(index ==1){
          url ='/smartOffice/StruggleCalendar';
       }else if(index ==2){
          url = '/smartOffice/StruggleMonthlyReport';
       }
       this.$router.replace(url)
     },
  }
};
</script>
<style lang="less" scoped>
@import "../../../assets/css/common.less";
.navbar_btn {
  .flex();
  justify-content: center;
  width: 100%;
  height: 1rem;
  margin:0 auto;
  background: #fff;
  box-shadow: 0px 0px .18rem 0px rgba(0, 0, 0, 0.05);
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index:100;
  .navbar_btnbg{
    position:absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    height: 100%;
    z-index:100;
  }
  .navbar_list {
    .flex();
    flex-direction: column;
    flex: 1;
    z-index:1000;
    align-items: center;
    .theme_img {
      display: block;
      width: .48rem;
      height: .48rem;
      margin-top:14px;
      margin-bottom:2px;
    }
    .smart_office{
      width:60px;
      height:60px;
      margin-top:6px;
      margin-bottom:0;
    }
    .theme_2img{
      width: .56rem;
      height: .56rem;
    }
    span {
      height:.28rem;
      font-size:.2rem;
      line-height:.28rem;
      color:@color99;
    }
    &.cur {
      span{
        color: #333;
      }
    }
  }
}
.theme_2span{
   height:.28rem;
   font-size:.2rem;
   line-height:.28rem;
    color:#1740DA;

}

</style>
